import axios from 'axios';
import config from '../config/config';

const API_URL = config.api.baseUrl;
// Ensure the exact environment variable name match with the .env file (with trailing underscore)
const IS_TURNSTILE_ENABLED = config.features.turnstile.enabled;

export const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Storage key for Turnstile token
export const TURNSTILE_TOKEN_KEY = 'turnstile_token';

axiosInstance.interceptors.request.use((config) => {
  // Add authentication token if available
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Add Turnstile token as a header only if feature is enabled
  if (IS_TURNSTILE_ENABLED) {
    const turnstileToken = sessionStorage.getItem(TURNSTILE_TOKEN_KEY);
    if (turnstileToken) {
      config.headers['X-Turnstile-Token'] = turnstileToken;
    }
  }

  return config;
});

// Response interceptor to handle 401 Unauthorized errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to home
      localStorage.removeItem('token');

      // Only redirect if not already on home page
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export const fetcher = (url: string) =>
  axiosInstance.get(url).then((res) => res.data);

// Helper functions to manage Turnstile token
export const turnstileTokenManager = {
  set: (token: string) => {
    if (IS_TURNSTILE_ENABLED) {
      sessionStorage.setItem(TURNSTILE_TOKEN_KEY, token);
    }
  },
  get: () => {
    if (!IS_TURNSTILE_ENABLED) return null;
    return sessionStorage.getItem(TURNSTILE_TOKEN_KEY);
  },
  clear: () => {
    if (IS_TURNSTILE_ENABLED) {
      sessionStorage.removeItem(TURNSTILE_TOKEN_KEY);
    }
  },
  isEnabled: () => IS_TURNSTILE_ENABLED
};